import { configureStore } from "@reduxjs/toolkit";
import { sidebarReducerInner } from "./sidebarSlice/Reducer";
import { tockenReducerInner } from "./AccessTocken/tocken";
import { loginReducerInner } from "./Login/loginReducer";
import { roleReducerInner } from "./Roles/Reducer";
import { userReducerInner } from "./Users/Reducer";
import { divisionReducerInner } from "./Division/Reducer";
import { applicationReducerInner } from "./Application/Reducer";
import { BUReducerInner } from "./BU/Reducer";
import { productReducerInner } from "./Product/Reducer";
import { contentReducerInner } from "./Content/Reducer";
import { applicationVR_ReducerInner } from "./ApplicationVR/Reducer";
import { VRcontentReducerInner } from "./ContentVR/Reducer";
import { permissionsReducerInner }from "./Permission/permission"

const store = configureStore({
  reducer: {
    // Login page and layout reducers
    sidebar: sidebarReducerInner.reducer,
    AccessTocken: tockenReducerInner.reducer,
    Login: loginReducerInner.reducer,

    // Normal page reducers
    BU: BUReducerInner.reducer,
    division: divisionReducerInner.reducer,
    role: roleReducerInner.reducer,
    user: userReducerInner.reducer,

    // AR page reducers
    application: applicationReducerInner.reducer,
    product: productReducerInner.reducer,
    content: contentReducerInner.reducer,

    // VR page reducers
    applicationVR: applicationVR_ReducerInner.reducer,
    VRcontent: VRcontentReducerInner.reducer,

    permissions: permissionsReducerInner.reducer,
  },
});

//Login and layout reducers
export const loginReducer = loginReducerInner.actions;
export const AccessTockenReducer = tockenReducerInner.actions;
export const sidebarReducer = sidebarReducerInner.actions;

// Normal page reducers
export const BUReducer = BUReducerInner.actions;
export const divisionReducer = divisionReducerInner.actions;
export const roleReducer = roleReducerInner.actions;
export const userReducer = userReducerInner.actions;

// AR page reducers
export const applicationReducer = applicationReducerInner.actions;
export const productReducer = productReducerInner.actions;
export const contentReducer = contentReducerInner.actions;

// VR page reducers
export const applicationVR_Reducer = applicationVR_ReducerInner.actions;
export const VRcontentReducer = VRcontentReducerInner.actions;
// Permissions reducer
export const permissionsReducer = permissionsReducerInner.actions;

export default store;
